import Modal from 'antd/lib/modal/Modal';
import React from 'react';

export type PageModalProps = {
  onCancel?: () => void;
  showAsModal?: boolean;
  visible?: boolean;
  width?: any;
};

export type PageProps = {
  children?: any;
  modalTitle?: React.ReactChild;
  centered?: boolean;
} & PageModalProps;

/**
 * Allowes a page to be displayed as modal
 */
const Page = ({
  children,
  modalTitle,
  showAsModal,
  width,
  ...otherProps
}: PageProps) => {
  if (showAsModal) {
    return (
      <Modal
        title={modalTitle}
        footer={null}
        width={width ?? '80%'}
        {...otherProps}
      >
        {children}
      </Modal>
    );
  }

  return children;
};

export default Page;
